





























import { Component, Vue } from "vue-property-decorator";
import { TaskTypeId } from "../entities/ids";
import TaskType from "../entities/task-type";
import TaskTypeNameInput from "../components/task-type/TaskTypeNameInput.vue";
import SelectOption from "@/common/ui/presenters/select-option";
import { getServiceTaskTypes } from "@/servicetask/api/service-tasks-api";

@Component({
  components: {
    TaskTypeNameInput
  }
})
export default class TaskTypeEditModal extends Vue {
  tasktype: TaskType = {
    id: 0,
    name: "",
    serviceTemplateTypeId: 0
  };

  get tasktypes(): TaskType[] {
    return this.$store.getters["tasktype/all"];
  }

  show(id: TaskTypeId) {
    const t = this.tasktypes.find(t => t.id === id);
    if (!t) return;
    this.tasktype = { ...t };
    this.$nextTick(() => {
      (this.$refs.modal as any).show();
    });
  }

  hide() {
    (this.$refs.modal as any).hide();
  }

  submit() {
    this.$store.dispatch("tasktype/save", {
      id: this.tasktype.id,
      name: this.tasktype.name,
      serviceTemplateTypeId: this.tasktype.serviceTemplateTypeId
    });
    this.$nextTick(this.hide);
  }

  cancel() {
    this.hide();
  }

  remove() {
    if (!confirm("本当に削除しますか？")) return;
    this.$store.dispatch("tasktype/remove", this.tasktype.id);
    this.$nextTick(this.hide);
  }

  public created() {
    this.initServiceTaskTypeOptions();
  }

  serviceTaskTypeOptions: SelectOption[] = [];

  async initServiceTaskTypeOptions() {
    this.serviceTaskTypeOptions = [{ text: "通常工程表", value: "" }].concat(
      (await getServiceTaskTypes()).map(t => ({
        text: t.name,
        value: String(t.id)
      }))
    );
  }
}
